"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontIconClassName = exports.iconColorClassName = exports.iconLightClassName = exports.iconRegularClassName = exports.iconFilledClassName = void 0;
exports.iconFilledClassName = "fui-Icon-filled";
exports.iconRegularClassName = "fui-Icon-regular";
exports.iconLightClassName = "fui-Icon-light";
exports.iconColorClassName = "fui-Icon-color";
exports.fontIconClassName = "fui-Icon-font";
